import { render, staticRenderFns } from "./TextareaEmojiPicker.vue?vue&type=template&id=b89ba096&scoped=true&"
import script from "./TextareaEmojiPicker.vue?vue&type=script&lang=js&"
export * from "./TextareaEmojiPicker.vue?vue&type=script&lang=js&"
import style0 from "./TextareaEmojiPicker.vue?vue&type=style&index=0&id=b89ba096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89ba096",
  null
  
)

export default component.exports